import React from 'react';

function WeaningRadio ({ isDisabled, ...props }) {
    return (
        <div>
            <div className='pt-[20px] relative px-[14px] font-"roboto" w-[100%] flex justify-between'>
                <label className='self-center text-[16px] text-[#7E7E7E] font-[500] leading-[30px]'>{props.title}</label>
            </div>
            <div className='flex flex-row ml-[30px] h-[38px]'>
                <label className='self-center font-"roboto" w-[8%] font-[400] text-[14px] leading-[15px] text-[#757575]'>
                    <input className='self-center' name={props.name} type='radio' onChange={props.formikState.handleChange} value={props.value1} checked={props.val.data === props.value1} disabled={isDisabled}/><span className='ml-1'>{props.value1}</span></label>
                <label className='self-center font-"roboto" w-[8%] font-[400] text-[14px] leading-[15px] text-[#757575]'>
                    <input className='self-center' name={props.name} type='radio' onChange={props.formikState.handleChange} value={props.value2} checked={props.val.data === props.value2} disabled={isDisabled}/><span className='ml-1'>{props.value2}</span>
                </label>
                {props.value3
                    ? <label className='self-center font-"roboto" w-[15%] font-[400] text-[14px] leading-[15px] text-[#757575]'>
                        <input className='self-center' name={props.name} type='radio' onChange={props.formikState.handleChange} value={props.value3} checked={props.val.data === props.value3} disabled={isDisabled}/><span className='ml-1'>{props.value3}</span></label>
                    : null}
                {props.value4
                    ? <label className='self-center font-"roboto" w-[15%] font-[400] text-[14px] leading-[15px] text-[#757575]'>
                        <input className='self-center' name={props.name} type='radio' onChange={props.formikState.handleChange} value={props.value4} checked={props.val.data === props.value4} disabled={isDisabled}/><span className='ml-1'>{props.value4}</span></label>
                    : null}
                {props.val.data === props.value2 && <input
                    className={`${props.out} h-[38px] text-[15px] self-center text-col border-[1px] w-[53%] border-[#E3E3E3] text-input bg-gray outline-none px-2`}
                    id={`${props.id}.remarks`}
                    name={`${props.id}.remarks`}
                    type={props.type}
                    placeholder={props.placeholder}
                    onChange={props.formikState.handleChange}
                    value={props.val.remarks}
                    disabled={isDisabled}
                />
                }
            </div>
        </div>
    );
}

export default WeaningRadio;
